import { render } from "./priceSlider.vue?vue&type=template&id=8ff7178a&scoped=true"
import script from "./priceSlider.vue?vue&type=script&lang=js"
export * from "./priceSlider.vue?vue&type=script&lang=js"

import "./priceSlider.vue?vue&type=style&index=0&id=8ff7178a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ff7178a"]])

export default __exports__